module.exports = __webpack_public_path__ + "static/media/vscode-icon.225fbbe0.png";